<!-- eslint-disable vue/custom-event-name-casing -->
<!-- Versione 1.5-->
<!-- 
    Changelog:
    v. 1.5 : 20241015 : agginto allinemaneto colonne
    v. 1.4 : 20240104 : messa scritta se non trova risultati
    v. 1.3 : 20230920 : messa opzione nascondere i comandi 
    v. 1.1 : 20230912 : messa opzione per switchare tra fontawesome embedded/standard
    v. 1.0 : 20230901 : setup

-->
<template>
    <div class="d-flex justify-content-end mb-1" v-if="mostraPager">
        <div class="pt-2">Elementi per pagina:&nbsp;</div>
        <div>
            <select class="form-control" v-model="elementiPagina" style="width:100px;" @change="$emit('CambiaElementi', elementiPagina)">
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
            </select>
        </div>

    </div>
    
  
  <table :class="'table ' + classiTable">
    <thead>
        <tr>
            <th v-for="c, ndx in colonneHeader" :key="ndx">
                {{ c }} &nbsp;
                <a @click="$emit('Ordina',ndx)" class="aOrdina" v-if="!colonneNoOrder.includes(colonne[ndx])">
                    <font-awesome-icon v-if="fontawesome=='embedded'" :icon="'fa-solid fa-arrow-down-short-wide'"></font-awesome-icon>
                    <i v-else :class="'fas fa-sort'"></i>
                </a>
            </th>
            <th></th>
        </tr>
    </thead>
    <tbody>
        <!-- *** MESSAGGIO TABELLA VUOTA *** -->
        <tr v-if="dati.length == 0">
            <td :colspan="colonneHeader.length">Nessun dato disponibile</td>
        </tr>
        <!-- *** DATI *** -->
        <tr v-for="e, ndx in dati" :key="ndx" @dblclick="$emit('Seleziona', e)">
            <td v-for="v, ndxv in colonne" :key="ndxv" :class="GetAlign(colonne[ndxv])">
                <template v-if="!IsBoolean(e, ndxv)"><span v-html="GetValue(e, ndxv)"></span></template>
                <template v-else>
                    <template v-if="fontawesome=='embedded'">
                        <font-awesome-icon :icon="'fa-solid fa-check'" v-if="GetValue(e, ndxv) == true" class="text-success"></font-awesome-icon>
                        <font-awesome-icon :icon="'fa-solid fa-times'" v-else class="text-dark"></font-awesome-icon>
                    </template>
                    <template v-else>
                        <i class="fas fa-check text-success" v-if="GetValue(e, ndxv) == true"></i>
                        <i class="fas fa-times text-dark" v-else></i>
                    </template>
                    
                </template>
            </td> 
            <td class="text-end" style="white-space: nowrap;">
                <template v-for="cmd, ndc in comandi" :key="ndc">
                    <!-- *** PER NASCONDERE I COMANDI: nella fonte dati specificare un campo come da esempio
                        {
                            ....
                            nascondiComando: ['TitoloComando1','TitoloComando2',...]

                        }
                    -->
                    <template v-if="e.nascondiComando != undefined && e.nascondiComando.includes(cmd.titolo)">
                        <!-- nasconde comando -->
                    </template>
                    <template v-else>
                        <a :title="cmd.titolo" @click="$emit(cmd.emetti, e)" class="aComandi" :class="cmd.iconaStile">
                            <font-awesome-icon  v-if="fontawesome=='embedded'" :icon="'fa-solid ' + cmd.icona"></font-awesome-icon>
                            <i v-else :class="'fas fa-sm fa-fw ' + cmd.icona"></i>
                        </a>
                    </template>
                    
                </template>
                
            </td>
        </tr>
    </tbody>
    <tfoot>
        <tr v-if="mostraPager">
            <td :colspan="colonne.length + 1">
                <div class="d-flex justify-content-between">
                    <div>Elementi totali {{ queryLength }}, pagina {{ currentPage }} di {{PagineTotali}}</div>
                    <div>
                        <button type="button" class="btn btn-sm btn-outline-dark mx-1" 
                        v-for="p, i in CalcolaNumeri" :key="i" :class="{'btnSelected': currentPage == p}"
                        @click="$emit('CambiaPagina', p)">{{ p }}</button>
                    </div>
                    <div>
                        <button type="button" class="btn btn-sm btn-outline-dark" @click="$emit('Precedente')" v-if="currentPage > 1">&lt;&nbsp;Precedente</button>
                        <button type="button" class="btn btn-sm btn-outline-dark" @click="$emit('Successiva')" v-if="currentPage < PagineTotali">Successiva&nbsp;&gt;</button>
                    </div>
                </div>

                
                
            </td>
        </tr>
        <tr v-else>
            <td :colspan="colonne.length + 1">
                <div>Elementi totali {{ queryLength }}</div>
            </td>
        </tr>
    </tfoot>
  </table>
</template>

<script>

export default {
    name: "GrigliaFacile",
    props: {
        mostraPager: {
            type: Boolean,
            default: false
        },
        classiTable: {
            type: String,
            default: ""
        },
        colonneHeader: [],
        colonne: [],
        colonneNoOrder: [],
        colonneAlign: [],  // array di oggetti: { column: '', align : '' }
        dati: [],
        comandi: [],
        queryLength: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        fontawesome: {
            type: String,
            default: "embedded"
        }
    },
    data: function() {
        return {
            elementiPagina: "10",
        }
    },
    methods: {
        GetValue(o, i) {
            return eval('o.' + this.colonne[i]);
        },
        IsBoolean(o, i) {
            let t = eval('typeof o.' + this.colonne[i]);
            if(t == 'boolean') return true;
            else return false;
        },
        GetAlign(nomeColonna) {
            let ris = "";
            for(let i = 0; i<this.colonneAlign.length; i++) {
                if(this.colonneAlign[i].column == nomeColonna) { ris = this.colonneAlign[i].align; }
            }
            //console.log(ris)
            return ris;
        },
    },
    computed: {
        PagineTotali() {
            return Math.ceil(this.queryLength  / this.elementiPagina);
        },
        CalcolaNumeri() {
            let res = [];
            let pages = Math.ceil(this.queryLength  / this.elementiPagina);
            let start = this.currentPage;
            if(this.currentPage == 1) start = 1;
            if(this.currentPage == 2) start = 1;
            if(this.currentPage >= 3) start = this.currentPage-2;
            for(let i = start; i < start + 4; i++) {
                if(i <= pages) {
                    res.push(i);
                }
            }

            return res;
        }

    } 
    
}
</script>

<style scoped>
    table th {
        
        padding-left:10px;
        padding-right:10px;
        padding-top:5px;
        padding-bottom:5px;
    }
    table thead {
        border-bottom:solid 2px #ccc;
    }
    
    table tfoot tr {
        border-top:solid 2px #1f1f1f;
    }

    a.aComandi {
        margin-right: 3px;
    }

    a.aOrdina {
        color: #ccc;
    }
    a.aOrdina :hover{
        color: #1f1f1f;
    }

    button.btnSelected {
        color: #fff;
        background-color: #666;
    }
</style>